export default __webpack_public_path__ + "static/media/workshops.abe21399.jpg";